import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import style from './style.module.scss'
import Header from "../../components/app/common/Header/Header";

import bgImage from '../../../public/resources/images/bg-banner-6.jpg'

const mapStateToProps = ({ settings, reservation }) => ({
  appName: settings.appName,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
  businessAddress: reservation?.businessDetails?.location?.address,
  businessName: reservation?.businessDetails?.name,
  backgroundImage: reservation?.reservationSetupDetails?.background_image_url,
  accessToken: reservation?.accessToken,
  firstName: reservation?.first_name || 'Profile',
  themeColor: reservation?.reservationSetupDetails?.theme_color || '#c71d11',
  businessID: reservation?.businessDetails?._id,
  loading: reservation?.loading,
  singInPopUp: reservation?.singInPopUp,
  firstForm: reservation?.firstForm,
})

const AuthLayout = ({
  children,
  appName,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
  businessAddress,
  businessName,
  backgroundImage,
  accessToken,
  firstName,
  themeColor,
  businessID,
  loading,
  singInPopUp,
  firstForm,
  intl: { formatMessage },
}) => {
  return (
    <Layout className="vb__layout">
      <Layout.Content>
        <div
          // style={{ background: "url(resources/images/banner.png)" }}
          className={classNames(`${style.container} auth-container`, {
            vb__layout__squaredBorders: isSquaredBorders,
            vb__layout__cardsShadow: isCardShadow,
            vb__layout__borderless: isBorderless,
            [style.white]: authPagesColor === 'white',
            [style.gray]: authPagesColor === 'gray',
          })}
        >
          <img src={backgroundImage || bgImage} className={classNames(`${style.bgImage} bg-image`)} alt="" />
          <div className={style.container}>
            <div className={style.content}>
              <Header accessToken={accessToken} businessID={businessID} loading={loading} firstName={firstName} themeColor={themeColor} singInPopUp={singInPopUp} firstForm={firstForm} isTransparent />
              <div className={style.formcon}>{children}</div>
              <div className="text-center mt-3 mb-3 font-size-14">
                {businessName && (
                  <div>
                    {' '}
                    {formatMessage({ id: 'text.copyright' }, { businessName })}{' '}
                  </div>
                )}
                {businessAddress && (
                  <>
                    <div>{businessAddress?.street}, {businessAddress?.city}, {businessAddress?.state_province}, {businessAddress?.country}, {businessAddress?.zip_postal_code}</div><br />
                  </>
                )}
                <div>Powered by {appName}</div><br />
                <div className={style.links}>
                  <a
                    href={`${process.env.REACT_APP_MAIN_URL}/terms`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms
                  </a>
                  |
                  <a
                    href={`${process.env.REACT_APP_MAIN_URL}/privacy`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(injectIntl(AuthLayout)))
